import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { FY25_01Classifier } from './fy25_01';
export class FY25_02Classifier extends FY25_01Classifier {
  // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
  filterComponentsLog({
    componentsLog,
    ttai
  }) {
    const _componentsLog = {};
    Object.entries(componentsLog).forEach(([_timestamp, value]) => {
      const timestamp = Number(_timestamp);
      if (Math.ceil(ttai) >= timestamp) {
        _componentsLog[timestamp] = value;
      }
    });
    return _componentsLog;
  }
  constructor() {
    super();
    _defineProperty(this, "revision", 'fy25.02');
    _defineProperty(this, "types", ['attr']);
    _defineProperty(this, "filters", [{
      name: 'not-visible',
      filter: ({
        type,
        ignoreReason
      }) => {
        return !(ignoreReason !== null && ignoreReason !== void 0 && ignoreReason.includes('not-visible')) && ignoreReason !== 'non-visual-style';
      }
    }]);
    _defineProperty(this, "removedFilters", []);
    this.mergeConfig();
  }
}
export const revFY25_02Classifier = new FY25_02Classifier();